import React from 'react';

import {
    cancelCustomerRecurringSpaceBooking,
    cancelCustomerRecurringBooking
} from 'school-space-client/api';
import { Link } from 'school-space-client/components';

const isProspective = state => state === 'prospective';

const SpaceCancelConfirmationMessage = () => (
    <>
        <p>
            This space will be removed from all future bookings. It is then available for other
            customers to book.
        </p>
        <p>
            Please be aware that you may be subject to the following{' '}
            <Link
                url="https://school-space.org/terms-conditions/school-space-cancellation-policy"
                isExternal
                opensInNewTab
            >
                cancellations fees
            </Link>
            .
        </p>
    </>
);

export const openRecurringSpaceBookingModal = ({
    openModal,
    types,
    recurringBooking,
    refetchBooking,
    originalRecurringSpaceBooking
}) => {
    const {
        id: recurringBookingId,
        customer: { id: customerId },
        day,
        recurrence,
        recurrenceString,
        startDate,
        endDate,
        school,
        site,
        stateId
    } = recurringBooking;

    const title =
        originalRecurringSpaceBooking && originalRecurringSpaceBooking.space
            ? 'Edit space'
            : 'Add new space';

    return openModal({
        type: types.recurringSpaceBooking,
        props: {
            title,
            subtitles: [
                'Choose space and time',
                ...(!isProspective(stateId) ? ['Review changes'] : [])
            ],
            school,
            site,
            day,
            recurrence,
            recurrenceString,
            startDate,
            endDate,
            recurringBookingId,
            originalRecurringSpaceBooking,
            customerId,
            onUpdate: refetchBooking
        }
    });
};

export const openSpaceCancellationModal = ({
    openModal,
    closeModal,
    types,
    recurringBooking,
    refetchBooking,
    recurringSpaceBookingId
}) => {
    const {
        id: recurringBookingId,
        customer: { id: customerId }
    } = recurringBooking;

    return openModal({
        type: types.confirmation,
        props: {
            confirmAction: () =>
                cancelCustomerRecurringSpaceBooking(
                    customerId,
                    recurringBookingId,
                    recurringSpaceBookingId
                )
                    .then(refetchBooking)
                    .then(closeModal),
            title: 'Are you sure you want to remove this space?',
            confirmText: 'Yes, remove space',
            confirmButtonState: 'warning',
            cancelText: 'No, keep space',
            message: SpaceCancelConfirmationMessage
        }
    });
};

export const openRecurringStartEndDatesModal = ({
    openModal,
    types,
    recurringBooking,
    refetchBooking
}) => {
    return openModal({
        type: types.recurringStartEndDates,
        props: {
            title: 'Edit start and end dates',
            subtitles: [''],
            originalRecurringBooking: recurringBooking,
            onUpdate: refetchBooking
        }
    });
};

export const openRecurringBookingCancellationModal = ({
    openModal,
    closeModal,
    types,
    recurringBooking,
    refetchBooking
}) => {
    const {
        id: recurringBookingId,
        customer: { id: customerId },
        stateId
    } = recurringBooking;

    return openModal({
        type: types.recurringCancellation,
        props: {
            title: 'Are you sure you want to cancel this repeat booking?',
            subtitles: [
                'Select cancellation reason',
                ...(!isProspective(stateId) ? ['Review changes'] : [])
            ],
            recurringBookingId,
            customerId,
            confirmAction: cancellationReason =>
                cancelCustomerRecurringBooking(customerId, recurringBookingId, cancellationReason)
                    .then(refetchBooking)
                    .then(closeModal)
        }
    });
};
